import PropTypes from "prop-types";
import { Box } from "@mui/material";
import DOMPurify from "dompurify";

import "src/utils/htmlSanitizer";

const SafeHtml = ({ html, sx, ...rest }) => {
    if (!html) {
        return null;
    }

    return <Box sx={sx} {...rest} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />;
};

SafeHtml.propTypes = {
    html: PropTypes.string,
    sx: PropTypes.object,
};

export default SafeHtml;
